const settingsStorageKey = "wolne-card-settings";

const defaultSettings = {
    "resultsOnPagePlaces": 12,
    "cardsSizePlaces": true,
    "sortingByPlaces" : 0,
    "resultsOnPageEvents": 12,
    "cardsSizeEvents": true,
    "sortingByEvents": 3,
    "userLocation": ""
};

function getStoredSettings(){
    try {
        return JSON.parse(window.localStorage.getItem(settingsStorageKey)) ?? {};
    } catch (error) {
        return {};
    }
}

function isValidPreference(key, value){
    if (key === "resultsOnPagePlaces" || key === "resultsOnPageEvents") {
        return [8, 12, 20, 40].includes(value);
    }

    if (key === "cardsSizePlaces" || key === "cardsSizeEvents") {
        return typeof value === "boolean";
    }

    if (key === "sortingByPlaces") {
        return Number.isInteger(value) && value >= 0 && value <= 5;
    }

    if (key === "sortingByEvents") {
        return Number.isInteger(value) && value >= 0 && value <= 4;
    }

    return false;
}

const storedSettings = getStoredSettings();
const settings = { ...defaultSettings };

Object.keys(storedSettings).forEach((key) => {
    if (isValidPreference(key, storedSettings[key])) {
        settings[key] = storedSettings[key];
    }
});

export function saveSetting(key, value){
    settings[key] = value;

    if (!isValidPreference(key, value)) {
        return;
    }

    try {
        const savedPreferences = getStoredSettings();
        window.localStorage.setItem(settingsStorageKey, JSON.stringify({ ...savedPreferences, [key]: value }));
    } catch (error) {
    }
}

export default settings;